import React from "react"

import YearComponent from "./year-component"

class YearContainer extends React.Component {

	render() {
		return (
			<YearComponent
				consulted={this.props.consulted}
				year={this.props.year}
				isGest={this.props.isGest}
				scenarii={this.props.scenarii}
				createFrom={this.props.scenarii.length == 0 ? "new" : "previous"}
				couldCreate={this.props.couldCreate}
				previousValidatedScenarioExists={this.props.previousValidatedScenarioExists}
				onCustomAction={this.props.onCustomAction}
				onCreate={this.props.onCreate}
				me={this.props.me}
			/>
		)
	}

}

export default YearContainer



// WEBPACK FOOTER //
// ./src/component/scenarii/manager/year-container.js